import {PageForm} from '/src/layouts/page';
import { useLocation } from 'react-router-dom';
import QuotePart from '/src/components/quote/QuotePart';

function RoleFormPage() {
    const location = useLocation();
    var data = null;
    var type = null;
    if (location.state !=null) {
        data =  location.state.data;
        type = location.state.type
    }

    return (
        <PageForm>
                {/* <RoleForm data={data} type={type}/> */}
                <QuotePart/>
        </PageForm>

    );
}
export default RoleFormPage;